<template>
  <div :class="['row full-width justify-center', isMobile ? 'q-py-md' : 'q-py-lg']">
    <div :class="['column col-11', isMobile ? undefined : 'q-px-sm']">

      <!-- title, image -->
      <div class="row full-width border-radius border-solid bg-white q-mb-md items-stretch text-grey-4">

        <!-- image -->
        <div v-if="!isMobile" class="col-3 q-mr-xl">
          <q-img class="border-radius" src="img/privacy.jpg" width="100%"/>
        </div>

        <!-- title -->
        <div :class="['column col-12 col-md-auto justify-center', isMobile ? 'q-pa-sm' : undefined]">

          <!-- english title -->
          <div v-if="!isMobile" class="border-radius bg-primary q-mb-lg q-px-md q-py-xs" style="width: fit-content">
            <div class="text-h6 text-weight-regular text-white" style="font-family: Bahnschrift">
              Privacy Policy
            </div>
          </div>

          <!-- persian title -->
          <div>

            <!-- mobile -->
            <div v-if="isMobile"
              class="text-subtitle1 text-bold text-center text-grey-9">
              سیاست حفظ اطلاعات و حریم خصوصی کاربران
            </div>

            <!-- desktop -->
            <h1 v-else class="no-margin text-weight-regular text-grey-9">
              سیاست حفظ اطلاعات و حریم خصوصی کاربران
            </h1>

          </div>

        </div>

      </div>

      <!-- content -->
      <div class="row full-width border-radius border-solid bg-white q-pa-md text-grey-4">

        <div class="column q-gutter-y-md text-black">

          <div class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">
            حامیانه یک پلتفرم نیکوکاری می‌باشد. این صفحه اطلاعات کافی در رابطه با حریم خصوصی و روش جمع آوری استفاده از
            آن‌ها را برای شما توضیح می‌دهد. شما با استفاده از خدمات حامیانه این شرایط را پذیرفته‌اید. اطلاعات شخصی جمع
            آوری شده توسط حامیانه جهت ارائه و بهبود خدمات این مجموعه می‌باشد. حامیانه اطلاعات شما را به اشتراک نمی‌گذارد
            و تنها در اختیار این مجموعه می‌باشند.
          </div>

          <div class="text-subtitle1 text-bold">
            جمع آوری اطلاعات و استفاده از آن‌ها
          </div>

          <div class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">
            جهت بهبود تجربه کاربری در هنگام استفاده از حامیانه، ممکن است از شما درخواست اطلاعاتی نماییم، اطلاعاتی که
            درخواست می‌شود توسط ما جمع آوری و ذخیره می‌شوند و طبق این سند استفاده می‌شوند. علاوه بر آن حامیانه ممکن است
            اطلاعات دیگری نیز به صورت خودکار جمع آوری نمایند از جمله نوع دستگاه شما، آی‌پی شما، سیستم عامل دستگاه شما
            (ما به هیچ عنوان به اطلاعات شخصی دستگاه شما دسترسی نداریم و نخواهیم داشت).
          </div>

          <div class="text-subtitle1 text-bold">
            استفاده از اطلاعات شخصی
          </div>

          <div class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">نام، نام خانوادگی،
            ایمیل، شماره تلفن و آدرس شما جهت ساخت حساب کاربری و کد ملی و اطلاعات حساب بانکی جهت عودت وجه نیاز است که به
            صورت رمزگذاری شده بر روی سرورهای حامیانه ذخیره می‌شوند.
          </div>

          <div class="text-subtitle1 text-bold">
            جمع آوری و تحلیل داده‌های کاربر
          </div>

          <div class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">
            جهت ایجاد یک تجربه شخصی و منحصر به فرد در وبسایت و نرم‌افزارهای این مجموعه این اطلاعات جمع‌آوری و تحلیل
            می‌شوند.
          </div>

          <div class="text-subtitle1 text-bold">
            کوکی‌ها
          </div>

          <div class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">
            "کوکی‌ها" فایل‌هایی با مقداری کم از داده‌ها هستند که معمولا از شناسه منحصر به فرد و ناشناس استفاده می کنند.
            این "کوکی‌ها" از وب‌سایت به مرورگر شما ارسال می‌شوند و همچنین بر روی دستگاه شما ذخیره می‌شوند. حامیانه از
            این "کوکی‌ها" برای ارائه یک تجربه کاربری منحصر به فرد استفاده می‌کند. همچنین حامیانه از دیگر سرویس‌ها نیز
            استفاده می‌نماید که ممکن است این اطلاعات توسط این سرویس‌های آمار سنجی و غیره جمع آوری شوند.
          </div>

          <div class="text-subtitle1 text-bold">
            امنیت
          </div>

          <div class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">
            تمامی اطلاعات شخصی ذخیره شده در حامیانه در سرورهای امن با دسترسی محدود ذخیره می‌شوند. همچنین این سرورها توسط
            متخصصین این امر بهینه‌سازی و پشتیبانی می‌شوند. اطلاعات شخصی شما به صورت رمز شده ذخیره می‌شوند.
          </div>

          <div class="text-subtitle1 text-bold">
            تغییرات در این سند
          </div>

          <div class="text-subtitle2 text-weight-regular text-justify" style="line-height: 28px">
            امکان به‌روز رسانی این سند در هر زمان وجود دارد و شما می توانید با مراجعه به این صفحه از آخرین تغییرات آن
            مطلع شوید.
          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import {useMeta} from "quasar";

export default {
  async preFetch({store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath}) {
    await store.dispatch('getMeta', {pageUrl: 'https://www.hamiane.com/privacy-policy'})
    let meta = {}
    meta.title = store.state.preFetch.pageMeta.metaTitle
    meta.description = store.state.preFetch.pageMeta.metaDescription
    meta.keywords = store.state.preFetch.pageMeta.metaKeywords
    meta.script = null
    return await store.dispatch('setMeta', meta)
  },
  name: "PrivacyPolicy",
  computed: {
    isMobile() {
      return this.$q.screen.lt.md
    }
  },
  mounted() {
    useMeta(this.$store.state.meta)
    this.$store.commit('setPageLoadState', true)
  }
}
</script>

<style scoped>
h1 {
  font-size: 22px !important;
  line-height: 28px;
}
</style>
